module.exports = __webpack_public_path__ + "img/logo.3b40a7a5.png";